import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { DateObject } from 'react-multi-date-picker';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';

import Calendar from '../../Calendar';
import { StyledContainer } from '../styles';

import type { InputCalendarProps } from './types';
export default function InputCalendar<T extends FieldValues>({
  control,
  css,
  helperText,
  label,
  name,
  ...props
}: InputCalendarProps<T>) {
  return (
    <StyledContainer>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            {typeof label === 'string' ? (
              <FormLabel component="legend">{label}</FormLabel>
            ) : (
              label
            )}

            <Calendar
              css={css}
              multiple
              {...props}
              value={value as Date[]}
              onChange={(dates: DateObject[]) => {
                const selectedDates =
                  dates
                    ?.filter((date) => date.isValid)
                    .map((date) => date.toDate())
                    .sort((a, b) => a.getTime() - b.getTime()) || [];
                onChange(selectedDates);
              }}
            />
            <FormHelperText>{error?.message || helperText}</FormHelperText>
          </FormControl>
        )}
      />
    </StyledContainer>
  );
}
